import { NumberFormatter } from "@mantine/core";

const numberColumn = (field = "id", headerName = "ID", width = 75, styles, editable) => {
  return {
    field: field,
    headerName: headerName,
    width: width,
    type: "number",
    align: "left",
    headerAlign: "left",
    editable: editable,
    renderCell: ({ value }) => (
      <NumberFormatter
        value={value}
        thousandSeparator=" "
        style={{ fontSize: 13, ...styles }}
      />
    ),
  };
};

export default numberColumn;
